export const MODEL_TYPE = 'internals';

/**
 * Body for `POST /v1/custom_models/` when saving a node's internals as a
 * reusable module. Unlike the other model types, `data` doesn't describe the
 * module — it points at the case node the server snapshots.
 */
export function buildInternalsModulePayload({ label, permissions, description, projectId, caseId, nodeId }) {
  return {
    model_type: MODEL_TYPE,
    permissions,
    ...(permissions === 'project' && { project_ids: [projectId] }),
    data: {
      case_id: caseId,
      node_id: nodeId,
      label,
      ...(description && { description }),
    },
  };
}
